export const SET_WAREHOUSE_LIST = "SET_WAREHOUSE_LIST";
export const ADD_WAREHOUSE = "ADD_WAREHOUSE";
export const SET_WAREHOUSE_EDIT_STATUS = "SET_WAREHOUSE_EDIT_STATUS";

export const setWarehouseList = (payload) => {
	return {
		type: SET_WAREHOUSE_LIST,
		payload,
	};
};

export const setWarehouseEditStatus = (payload) => {
	return {
		type: SET_WAREHOUSE_EDIT_STATUS,
		payload,
	};
};
